import "core-js/stable";
import "regenerator-runtime/runtime";

export const PAGES_ERRORED = "PAGES_ERRORED";
export const PAGES_HAVE_VALUES = "PAGES_HAVE_VALUES";
export const PAGES_COMPLETED = "PAGES_COMPLETED";
export const PAGES_COMPLETED_ADD = "PAGES_COMPLETED_ADD";
export const PAGES_COMPLETED_REMOVE = "PAGES_COMPLETED_REMOVE";
export const ERRORS_OBJECT = "ERRORS_OBJECT";
export const FORM_VISIT_STATUS = "FORM_VISIT_STATUS";
export const PAGES_VISITED = "PAGES_VISITED";
export const PAGE_VISITED = "PAGE_VISITED";
export const PAGE_VISITED_OVERRIDE = "PAGE_VISITED_OVERRIDE";
export const ADD_TO_GLOBAL_ERRORS_OBJECT = "ADD_TO_GLOBAL_ERRORS_OBJECT";
export const ADD_PAGE_TO_GLOBAL_ERRORS = "ADD_PAGE_TO_GLOBAL_ERRORS";
export const REMOVE_FROM_GLOBAL_ERRORS_OBJECT =
  "REMOVE_FROM_GLOBAL_ERRORS_OBJECT";
export const SHOW_WARNING = "SHOW_WARNING";
export const DONT_SHOW_WARNING = "DONT_SHOW_WARNING";
export const ADD_TO_ALL_ERRORS_AND_ERRORS = "ADD_TO_ALL_ERRORS_AND_ERRORS";
export const ADD_WORKPLACE = "ADD_WORKPLACE";
export const REMOVE_WORKPLACE = "REMOVE_WORKPLACE";
export const ADD_RECRUITER = "ADD_RECRUITER";
export const REMOVE_RECRUITER = "REMOVE_RECRUITER";
export const REMOVE_ERROR_FOR_SECTION = "REMOVE_ERROR_FOR_SECTION";
export const REMOVE_FIELD_FROM_GLOBAL_ERRORS_OBJECT =
  "REMOVE_FIELD_FROM_GLOBAL_ERRORS_OBJECT";

const initialState = {
  _all_errors: [],
  _errors: [],
  _complete: [],
  _values: [],
  _visited: [],
  _first_time: true,
  _show_warning: [],
  _workplaces: [],
  _recruiters: [],
};

export default {
  fieldArrays: (state, action) => {
    state = Object.assign(initialState, state);
    switch (action.type) {
      case PAGES_ERRORED:
        return {
          ...state,
          _errors: action.payload,
        };
      case ADD_TO_GLOBAL_ERRORS_OBJECT:
        let new_errors_add = state._all_errors.slice(0);
        new_errors_add = new_errors_add.concat(action.payload);
        return {
          ...state,
          _all_errors: new_errors_add,
        };

      case ADD_PAGE_TO_GLOBAL_ERRORS:
        let new_error_pages = state._errors.slice(0);
        new_error_pages = new_error_pages.concat(action.payload);
        return {
          ...state,
          _errors: new_error_pages,
        };

      case ADD_WORKPLACE:
        const workplaceId = action.payload.id;
        const oldWorkplaces = [...state._workplaces];
        let newWorkplaces = [];

        if (
          action.payload.addnl_worksites_state_id === null ||
          action.payload.addnl_worksites_msa === null
        ) {
          return null;
        }
        if (!oldWorkplaces.map((owp) => owp.id).includes(workplaceId)) {
          newWorkplaces = [...state._workplaces, action.payload];
        } else {
          newWorkplaces = oldWorkplaces;
        }

        return {
          ...state,
          _workplaces: newWorkplaces,
        };

      case REMOVE_WORKPLACE:
        return {
          ...state,
          _workplaces: state._workplaces.filter(
            (wor) => wor.id !== action.payload
          ),
        };

      case ADD_RECRUITER:
        const recruiterId = action.payload.id;
        const oldRecruiter = [...state._recruiters];
        let newRecruiters = [];

        if (!oldRecruiter.map((ort) => ort.id).includes(recruiterId)) {
          newRecruiters = [...state._recruiters, action.payload];
        } else {
          newRecruiters = oldRecruiter;
        }

        return {
          ...state,
          _recruiters: newRecruiters,
        };

      case REMOVE_RECRUITER:
        return {
          ...state,
          _recruiters: state._recruiters.filter(
            (rec) => rec.id !== action.payload
          ),
        };

      case ADD_TO_ALL_ERRORS_AND_ERRORS:
        const oldErrors = [...state._errors];
        const oldVisited = [...state._visited];
        const oldValues = [...state._values];
        let newErrors = [];
        let newVisited = [];
        let newValues = [];

        // Todo: Need to revisit this... what the h is going on here ?
        if (
          !oldErrors
            .map((oe) => oe.toString())
            .includes(action.payload._error.toString())
        ) {
          newErrors = [...state._errors, action.payload._error];
        } else {
          newErrors = oldErrors;
        }

        if (
          !oldVisited
            .map((ovt) => ovt.toString())
            .includes(action.payload._visit.toString())
        ) {
          newVisited = [...state._visited, action.payload._visit];
        } else {
          newVisited = oldVisited;
        }

        if (
          !oldValues
            .map((ovl) => ovl.toString())
            .includes(action.payload._value.toString())
        ) {
          newValues = [...state._values, action.payload._value];
        } else {
          newValues = oldValues;
        }

        return {
          ...state,
          _all_errors: [...state._all_errors, action.payload._all_error],
          _errors: newErrors,
          _visited: newVisited,
          _values: newValues,
          _complete: state._complete.filter(
            (com) => com !== action.payload._complete
          ),
        };

      case REMOVE_ERROR_FOR_SECTION:
        const page = action.payload;
        return {
          ...state,
          _all_errors: [...state._all_errors].filter((ae) => ae.page !== page),
          _errors: [...state._errors].filter((er) => er !== page),
          _visited: [...state._visited].filter((vt) => vt !== page),
          _values: [...state._values].filter((vl) => vl !== page),
        };

      case REMOVE_FROM_GLOBAL_ERRORS_OBJECT:
        let new_errors = state._all_errors.slice(0);
        new_errors = new_errors.filter((err) => err.message !== action.payload); // payload is error message
        return {
          ...state,
          _all_errors: new_errors,
        };

      case REMOVE_FIELD_FROM_GLOBAL_ERRORS_OBJECT:
        let newer_errors = state._all_errors.slice(0);
        newer_errors = newer_errors.filter(
          (err) => err.field !== action.payload
        ); // payload is error field aka the machine name
        return {
          ...state,
          _all_errors: newer_errors,
        };

      case SHOW_WARNING:
        if (state._show_warning.indexOf(action.payload) === -1) {
          return {
            ...state,
            _show_warning: state._show_warning.concat(action.payload),
          };
        } else {
          return {
            ...state,
          };
        }

      case DONT_SHOW_WARNING:
        if (state._show_warning.indexOf(action.payload) > -1) {
          return {
            ...state,
            _show_warning: state._show_warning.filter(
              (warning) => warning != action.payload
            ),
          };
        } else {
          return {
            ...state,
          };
        }

      case PAGES_COMPLETED:
        return {
          ...state,
          _complete: action.payload,
        };
      case PAGES_COMPLETED_ADD:
        return {
          ...state,
          _complete: state._complete.concat(action.payload),
        };
      case PAGES_COMPLETED_REMOVE:
        return {
          ...state,
          _complete: state._complete.filter(
            (complete) => complete != action.payload
          ),
        };
      case PAGES_HAVE_VALUES:
        return {
          ...state,
          _values: state._values.concatOnce(action.payload),
        };
      case ERRORS_OBJECT:
        return {
          ...state,
          _all_errors: action.payload,
        };
      case FORM_VISIT_STATUS:
        return {
          ...state,
          _first_time: action.payload,
        };
      case PAGES_VISITED:
        // used on form INIT
        return {
          ...state,
          _visited: state._visited.concatOnce(action.payload),
        };
      case PAGE_VISITED:
        // used on page navigation
        // don't append to visited list if there were no values on 'visited'/'submitted' page
        if (state._values.indexOf(action.payload[0]) > -1) {
          return {
            ...state,
            _visited: state._visited.concatOnce(action.payload),
          };
        } else {
          return {
            ...state,
          };
        }
      case PAGE_VISITED_OVERRIDE:
        // used on page navigation
        // don't append to visited list if there were no values on 'visited'/'submitted' page
        if (state._visited.indexOf(action.payload[0]) === -1) {
          return {
            ...state,
            _visited: state._visited.concatOnce(action.payload),
          };
        } else {
          return {
            ...state,
          };
        }

      default:
        return state;
    }
  },
};
